import React from 'react';

export default function WhiteText() {
  return <span className="text-transparent">A</span>;
}
